import React from 'react';

import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';

import Page from 'components/page/page.component';
import DocumentList from 'components/document-list/document-list.component';

import { ReportDocs } from './reports';

const Reports = () => {
    return (
        <Page
            heroTitle="Reports"
            heroText="Publications and reports on Muncie housing and redevelopment"
            heroSize="small"
        >
            <Container>
                <Row>
                    <Col xs="12">
                        <DocumentList listTitle="meeings" documents={ReportDocs} />
                    </Col>
                </Row>
            </Container>
        </Page>
    );
};

export default Reports;
